export const jsonHeaders: any = {
	Accept: 'application/json',
	'Content-Type': 'application/json',
};
